
































































































import _ from 'lodash'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { isDecimal } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'

@Component

export default class ComponentModalCriarEditarTaxaAluguel extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { formItemTaxaAluguel: any }

  searchPrestador: string = ''
  loadingPrestadorFilter: boolean = false
  prestadoresDebounced = _.debounce(async (filtro: string) => {
    await this.getFinanceiroStore.getPrestadorTaxaAluguelAll({ limite: 20, filtro })
    this.loadingPrestadorFilter = false
  }, 500)

  formItemTaxaAluguelRules: any = {
    valid: true,
    fontePagadoraId: [(v: string) => !!v || 'Campo obrigatório'],
  }

  validateValor(value: string) {
    if (isDecimal(value)) return 'Formato inválido.'
    return true
  }

  dicaValor: string = 'Use somente números inteiros ou decimais separados por ponto (.)'

  loadCreateOrUpdateConfigParametro: boolean = false
  get loadingCreateOrUpdateConfigParametro() { return this.loadCreateOrUpdateConfigParametro }
  set loadingCreateOrUpdateConfigParametro(value: boolean) { this.loadCreateOrUpdateConfigParametro = value }

  get modalCriarParametrosAplicacao() { return this.getFinanceiroStore.modal.criarParametrosAplicacao }
  set modalCriarParametrosAplicacao(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarParametrosAplicacao', value }) }

  get prestadores(): any[] {
    return this.getFinanceiroStore.prestadoresLista.slice(1) || []
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  async fetchPrestadores() {
    const filtro = (this.searchPrestador || '').trim()

    if (filtro.length < 3) {
      this.loadingPrestadorFilter = false

      if (!filtro) {
        await this.getFinanceiroStore.getPrestadorTaxaAluguelAll({ limite: 20 })
      }

      return
    }

    this.loadingPrestadorFilter = true
    this.prestadoresDebounced(filtro)
  }

  async createOrUpdateConfigParametro() {
    this.loadingCreateOrUpdateConfigParametro = true

    if (this.$refs.formItemTaxaAluguel.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.criarParametroAplicacaoTaxaAluguel()
        : await this.getFinanceiroStore.atualizarParametroAplicacaoTaxaAluguel()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarParametrosAplicacao = false
          this.loadingCreateOrUpdateConfigParametro = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarParametrosAplicacao = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdateConfigParametro = false
  }

  @Watch('getFinanceiroStore.prestadoresLista')
  onChangePrestadoresLista(value) {
    if (value) this.loadingPrestadorFilter = false
  }

  @Watch('modalCriarParametrosAplicacao')
  onChangemodalCriarParametrosAplicacao(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemParametroAplicacaoTaxaAluguel()
      this.getFinanceiroStore.clearOriginalItemParametroAplicacaoTaxaAluguel()
      this.$refs.formItemTaxaAluguel.resetValidation()
      this.searchPrestador = ''
      this.loadingPrestadorFilter = false
    } else {
      this.searchPrestador = ''
    }
  }
}
